import React from "react";

import moment from "moment";

import { getCurrentPlatformTermsAndConditions } from "services";

import { formatDate, saveFile, useGetLatestPlatformContract, useTranslation } from "utils";

import { USER_TYPE, userType } from "models";

import { Checkbox, Flex, GuidanceLink } from "components";

type PlatformTermsProps = {
  userType: userType;
  checkboxState: boolean;
  setCheckboxState: (state: boolean) => void;
};

export const PlatformTerms = ({ userType, checkboxState, setCheckboxState }: PlatformTermsProps) => {
  const { t } = useTranslation("dashboard");
  const platformContract = useGetLatestPlatformContract();

  const handlePlatformTermsClick = async () => {
    const data = await getCurrentPlatformTermsAndConditions();
    saveFile(data, `${t("termsOverlay.platformTermsFileName")}.pdf`);
  };

  return (
    <>
      <Flex className="margin-top-250" align="center" gap="0.25rem">
        {userType === USER_TYPE.EXISTING && <Checkbox checked={checkboxState} onClick={() => setCheckboxState(!checkboxState)} />}
        <h3>{t("termsOverlay.platformTerms")}</h3>
      </Flex>

      {userType === USER_TYPE.EXISTING && platformContract.data?.createdAt && (
        <p>
          {t("termsOverlay.deadline", {
            createdAt: formatDate(platformContract.data?.createdAt, "LL", moment.ISO_8601),
            signBy: formatDate(
              moment(platformContract.data?.createdAt)
                .add(30, "days")
                .toISOString(),
              "LL",
              moment.ISO_8601
            ),
          })}
        </p>
      )}
      <p>{t(`termsOverlay.${userType}.platformTermsDescription`)}</p>
      <Flex align="center" gap="0.25rem">
        <span>{t("termsOverlay.linkDescription")}</span>
        <GuidanceLink text={t("termsOverlay.platformTermsLink")} onClick={handlePlatformTermsClick} />
      </Flex>
    </>
  );
};

export default PlatformTerms;
